import Mailmagazine from './Mailmagazine'

export default Mailmagazine
